import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import goaldetail from './goaldetail.store'
import anchorpage from './anchorpage.store'
import customgoal from './customgoal.store'
import customanchor from './customanchor.store'
import presentlevels from './presentlevels'
import favorites from './favorites'
import contentAccess from './content_access'
import visibility from './visibility.store'
import contentProfile from '@/contentprofile/store'
import udlIndex from '@/components/strategies/udlindex/store'
import library from './library'
import browse from './browse'
import { initAuthenticatedTracking, initUnauthenticatedTracking } from '@/tracking'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    contentProfile,
    anchorpage,
    goaldetail,
    favorites,
    contentAccess,
    library,
    presentlevels,
    customgoal,
    customanchor,
    visibility,
    browse,
    udlIndex,
  },
  state: {
    _initializedTracking: false,
    _initializedAuthenticatedTracking: false,

    currentUrl: '',

    showWikiTextPreviewer: false,
  },
  mutations: {
    trackingInitialized(state) {
      state._initializedTracking = true
    },
    authenticatedTrackingInitialized(state) {
      state._initializedAuthenticatedTracking = true
    },
    setCurrentUrl(state, newUrl) {
      state.currentUrl = newUrl
    },
    setWikiTextPreviewer(state, flag) {
      state.showWikiTextPreviewer = flag
    },
  },
  actions: {
    initTracking(context) {
      if (!context.state._initializedTracking) {
        context.commit('trackingInitialized')
      }
    },
    initAuthenticatedTracking(context, payload) {
      if (!context.state._initializedAuthenticatedTracking) {
        try {
          initAuthenticatedTracking(payload)
        } catch (err) {
          console.error(`Could not fully init app: ${err}`)
        }
        context.commit('authenticatedTrackingInitialized')
      }
    },
    initUnauthenticatedTracking(context, payload) {
      if (!context.state._initializedAuthenticatedTracking) {
        try {
          initUnauthenticatedTracking(payload)
        } catch (err) {
          console.error(`Could not initialize unauthenticated tracking: ${err}`)
        }
      }
    },
    updateCurrentUrl(context, newUrl) {
      context.commit('setCurrentUrl', newUrl)
    },
  },
})
